import filter from 'lodash/filter';

import { can } from 'services/can';
import { PermissionsMapping } from 'common/constants/role-intents';
import flags from 'containers/flags/service';

export const MAX_DIMENSION_SENDTOFTA_COUNT = 5;

export function isMaxFta(customDimensions) {
    return (
        filter(customDimensions, dimension => dimension.sendToFta === true).length ===
        MAX_DIMENSION_SENDTOFTA_COUNT
    );
}

export function canEditCustomDimension(campaign) {
    if (campaign && campaign.isArchived && !flags.isEnabled('efb_201_campaign_expiry')) {
        return false;
    }

    return can(PermissionsMapping.CAMPAIGN__VIEW_AND_EDIT);
}
